import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Tab,
  Typography
} from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";

import toast from "react-hot-toast";
import { ExamResultDetailsTypes } from "../../types/onlineExam.interface";
import moment from "moment";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import ExaminiResultWrapper from "./ExaminiResultWrapper";
import TabPanel from "@mui/lab/TabPanel";
import WithOutFormAutoComplete from "../../components/WithoutControlAutoComplete";
import Sidebar from "../../components/Sidebar";
import ResultCard from "./ResultCard";
import ResultSection from "./ResultSection";
import PDFViewer from "../../components/PDFViewer";
import { MoveLeft } from "lucide-react";
import useUserStore from "../../stores/useUserStores";

type ExaminiResultProps = {
  exam_group_id: number;
};
const ExaminiResult: FC<ExaminiResultProps> = ({
  exam_group_id,
}): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const [side, setside] = useState(false);
  const [examStatus, setExamStatus] = useState<
    "PUBLISHED" | "ALL" | "GENERATED"
  >("ALL");
  const [selectedExamForCentreConfig, setSelectedExamForCenterConfig] =
    useState<number | null>(null);
  const [examGroupOptions, setExamGroupOptions] = useState<Array<any>>([]);
  const [examResultDetails, setExamResultDetails] =
    useState<ExamResultDetailsTypes | null>(null);

  // const getExamPapersByExamNames = async ({
  //   _selectedExam
  // }: {
  //   _selectedExam: number | null | undefined;
  // }) => {
  //   if (!_selectedExam) return;
  //   try {
  //     const response = await axios.post(
  //       baseServiceUrl + urls.candidateExamConducted,
  //       {
  //         exam_group: _selectedExam,
  //       },
  //       {
  //         headers: {
  //           Authorization: "Bearer " + userDetails.token
  //         }
  //       }
  //     );
  //     setExamResultDetails(response.data);
  //   } catch (error: any) {
  //     toast.error(error?.response?.data?.message);
  //   }
  // };

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const response = await axios.get(
  //         baseServiceUrl + urls.getExamGroupList,
  //         {
  //           headers: {
  //             Authorization: "Bearer " + userDetails.token
  //           }
  //         }
  //       );
  //       setExamGroupOptions(response.data);
  //     } catch (error: any) {
  //       toast.error(error?.response?.data?.message || "Something went wrong");
  //     }
  //   })();
  // }, []);

  // const handleChange = (
  //   event: React.SyntheticEvent,
  //   newValue: "PUBLISHED" | "ALL" | "GENERATED"
  // ) => {
  //   setExamStatus(newValue);
  //   getExamPapersByExamNames({
  //     _selectedExam: selectedExamForCentreConfig
  //   });
  // };

  // const handleOnChangeExams = (value: any) => {
  //   if (value && Number(value) > 0) {
  //     setSelectedExamForCenterConfig(value);
  //     getExamPapersByExamNames({ _selectedExam: Number(value) });
  //   } else {
  //     setSelectedExamForCenterConfig(null);
  //     setExamResultDetails(null);
  //   }
  // };
  const handleside = () => {
    setside((prev) => !prev);
  };

  return (
    <div className=" flex">
      <div className=" w-[100vw] min-h-[88vh]  ">
        <div className="mt-2 ml-8">
          {/* <button className="bg-gray-200 border border-transparent hover:border-gray-300 hover:bg-white  w-[125px] flex items-center p-1 px-3  gap-x-5" onClick={()=>navigate("/Dashboard/test-series")}>
            <MoveLeft className="text-gray-500" />
            <p className="text-gray-600 text-sm">Go Back</p>
          </button> */}
        </div>
        {exam_group_id ? (
          <div className="pt-1">
            <PDFViewer examId={Number(exam_group_id)} />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ExaminiResult;
